/* eslint perfectionist/sort-modules: "off" */
/* eslint perfectionist/sort-objects: "off" */
export const PHONE = 320
export const PHONE_WIDE = 576
export const TABLET = 768
export const TABLET_WIDE = 1024
export const DESKTOP = 1248
export const DESKTOP_WIDE = 1440
export const FULL_HD = 1920

export const mediaQueries = {
  phone: {
    down: window.matchMedia(`(max-width: ${PHONE - 1}px)`),
    up: window.matchMedia(`(min-width: ${PHONE}px)`)
  },
  phoneWide: {
    down: window.matchMedia(`(max-width: ${PHONE_WIDE - 1}px)`),
    up: window.matchMedia(`(min-width: ${PHONE_WIDE}px)`)
  },
  tablet: {
    down: window.matchMedia(`(max-width: ${TABLET - 1}px)`),
    up: window.matchMedia(`(min-width: ${TABLET}px)`)
  },
  tabletWide: {
    down: window.matchMedia(`(max-width: ${TABLET_WIDE - 1}px)`),
    up: window.matchMedia(`(min-width: ${TABLET_WIDE}px)`)
  },
  desktop: {
    down: window.matchMedia(`(max-width: ${DESKTOP - 1}px)`),
    up: window.matchMedia(`(min-width: ${DESKTOP}px)`)
  },
  desktopWide: {
    down: window.matchMedia(`(max-width: ${DESKTOP_WIDE - 1}px)`),
    up: window.matchMedia(`(min-width: ${DESKTOP_WIDE}px)`)
  },
  fullHd: {
    down: window.matchMedia(`(max-width: ${FULL_HD - 1}px)`),
    up: window.matchMedia(`(min-width: ${FULL_HD}px)`)
  }
}

export const isPhoneUp = (): boolean => {
  return mediaQueries.phone.up.matches
}

export const isPhoneWideUp = (): boolean => {
  return mediaQueries.phoneWide.up.matches
}

export const isTabletUp = (): boolean => {
  return mediaQueries.tablet.up.matches
}

export const isTabletWideUp = (): boolean => {
  return mediaQueries.tabletWide.up.matches
}

export const isDesktopUp = (): boolean => {
  return mediaQueries.desktop.up.matches
}

export const isDesktopWideUp = (): boolean => {
  return mediaQueries.desktopWide.up.matches
}

export const isFullHdUp = (): boolean => {
  return mediaQueries.fullHd.up.matches
}

export const isPhoneDown = (): boolean => {
  return mediaQueries.phone.down.matches
}

export const isPhoneWideDown = (): boolean => {
  return mediaQueries.phoneWide.down.matches
}

export const isTabletDown = (): boolean => {
  return mediaQueries.tablet.down.matches
}

export const isTabletWideDown = (): boolean => {
  return mediaQueries.tabletWide.down.matches
}

export const isDesktopDown = (): boolean => {
  return mediaQueries.desktop.down.matches
}

export const isDesktopWideDown = (): boolean => {
  return mediaQueries.desktopWide.down.matches
}

export const isFullHdDown = (): boolean => {
  return mediaQueries.fullHd.down.matches
}
